var React = require('react');

function ClockBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 1.25A6.758 6.758 0 001.25 8 6.758 6.758 0 008 14.75 6.758 6.758 0 0014.75 8 6.758 6.758 0 008 1.25zm2.73 9.082l-.398.398a.281.281 0 01-.397 0L7.602 8.398A.562.562 0 017.438 8V3.5a.28.28 0 01.28-.281h.563c.156 0 .282.126.282.281v4.267l2.167 2.168a.28.28 0 010 .397z"}));
}

ClockBlack.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ClockBlack;

ClockBlack.default = ClockBlack;
